import React, { memo, useEffect, useState } from 'react';
const closeButtonStyle = {
  WebkitMaskImage: "url('/svgs/close.svg')",
  maskImage: "url('/svgs/close.svg')",
};

interface QuoteStageModalProps {
  toggleModal: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const QuoteStageModal: React.FC<QuoteStageModalProps> = ({ toggleModal, onClose, children }: QuoteStageModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(toggleModal);

  useEffect(() => {
    document.body.style.overflow = toggleModal ? 'hidden' : 'auto';
    setIsOpen(toggleModal);

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [toggleModal]);

  return (
    <>
      <div className={`${!isOpen && 'opacity-0 pointer-events-none'} fixed top-6 right-7 cursor-pointer w-6 h-6 z-[60] transition-all duration-500`}>
        <button
          className="h-[24px] w-[24px] bg-no-repeat bg-system/white"
          aria-label="close menu"
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
          style={closeButtonStyle}
        />
      </div>

      <div
        className={`${!isOpen && 'opacity-0 pointer-events-none'} overflow-auto fixed h-screen w-screen z-[59] bg-[#0B212E] bg-opacity-90 top-0 left-0 cursor-pointer py-0 transition-all duration-500 backdrop-blur-sm`}
        onClick={() => onClose()}
      >
        <div className="relative container mx-auto justify-center h-full w-full py-40 grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6 md:col-start-4 md:col-end-10 bg-blue-500 p-4 pb-10">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(QuoteStageModal);